<app-tab-form-modal [isModal]="isModal" [showSave]="showSave" [showBack]="showBack">
  <app-base-comments
    [commentService]="salesOrderHeaderCommentService"
    [id]="id"
    [commentStart]="commentStart"
    [oneRecord]="oneRecord"
  >
  </app-base-comments>
</app-tab-form-modal>
